export const searchOptions = [
	{ label: 'SKU', value: 'sku' },
	{ label: 'Title', value: 'productTitle' }
];

export const defaultFilter = {
	searchOptionType: searchOptions[0].value,
	searchValue: ''
};
